import api_config from '../config/api'

export default {
	getOurClients() {
		return api_config.get('api/our_client')
	},
}
